import {configureEcho} from "@laravel/echo-vue";
import {websocketHost} from "@/config";
import {useAuthStore} from "@/stores";

export const setup = function () {
    configureEcho({
        broadcaster: 'reverb',
        key: "1EI7f9vVSaV9X3OfqaEv",
        wsHost: websocketHost,
        wsPort: 443,
        wssPort: 443,
        authHost: websocketHost, // Set the base host for `/broadcasting/auth`
        authEndpoint: `https://${websocketHost}/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: `Bearer ${useAuthStore().token}`,
            },
        },
        bearerToken: useAuthStore().token,
        encrypted: true,
        forceTLS: true,

    });
}